import { EVENT_KEYNAMES as e } from "../../common/constants/index.js";
import { returnFirstEl as t } from "../../common/utils/index.js";
import { t as n } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import r from "../../common/mixins/modal.js";
import i from "../../common/mixins/mode.js";
import { DialtoneLocalization as a } from "../../localization/index.js";
import o from "../button/button.js";
import s from "../../shared/sr_only_close_button.js";
import { Teleport as c, Transition as l, createBlock as u, createCommentVNode as d, createElementBlock as f, createElementVNode as p, createVNode as m, mergeProps as h, normalizeClass as g, openBlock as _, resolveComponent as v, toHandlers as y, withCtx as b } from "vue";
import { DtIconClose as x } from "@dialpad/dialtone-icons/vue";
//#region components/image_viewer/image_viewer.vue
var S = {
	compatConfig: { MODE: 3 },
	name: "DtImageViewer",
	components: {
		SrOnlyCloseButton: s,
		DtButton: o,
		DtIconClose: x
	},
	mixins: [r, i],
	props: {
		appendTo: {
			type: String,
			default: "body"
		},
		open: {
			type: [Boolean, null],
			default: null
		},
		imageSrc: {
			type: String,
			required: !0
		},
		imageAlt: {
			type: String,
			required: !0
		},
		imageButtonClass: {
			type: String,
			required: !1,
			default: ""
		},
		ariaLabel: {
			type: String,
			required: !0
		}
	},
	emits: ["opened", "update:open"],
	data() {
		return {
			showCloseButton: !0,
			isOpen: !1,
			i18n: new a()
		};
	},
	computed: {
		modalListeners() {
			return {
				click: (e) => {
					e.target === e.currentTarget && this.close();
				},
				keydown: (t) => {
					switch (t.code) {
						case e.esc:
						case e.escape:
							this.close();
							break;
						case e.tab:
							this.trapFocus(t);
							break;
					}
				}
			};
		},
		closeButtonTitle() {
			return this.i18n.$t("DIALTONE_CLOSE_BUTTON");
		}
	},
	watch: {
		isOpen: {
			immediate: !0,
			handler(e) {
				e ? this.previousActiveElement = document.activeElement : (this.previousActiveElement?.focus(), this.previousActiveElement = null);
			}
		},
		open: {
			handler: function(e) {
				e !== null && (this.isOpen = e);
			},
			immediate: !0
		}
	},
	methods: {
		openModal() {
			this.open === null && (this.isOpen = !0, this.showCloseButton = !0, this.$emit("opened", !0), setTimeout(() => {
				this.focusAfterOpen();
			}));
		},
		close() {
			this.isOpen = !1, this.$emit("opened", !1), this.open !== null && this.$emit("update:open", !1);
		},
		focusAfterOpen() {
			t(this.$refs.closeImage?.$el)?.focus();
		},
		trapFocus(e) {
			this.isOpen && this.focusTrappedTabPress(e);
		}
	}
}, C = ["src", "alt"], w = ["aria-hidden"], T = {
	"data-qa": "dt-image-viewer-full",
	class: "d-image-viewer__full",
	role: "dialog",
	"aria-modal": "true"
}, E = ["src", "alt"];
function D(e, t, n, r, i, a) {
	let o = v("dt-button"), s = v("dt-icon-close"), x = v("sr-only-close-button");
	return _(), f("div", null, [m(o, {
		"data-qa": "dt-image-viewer-preview",
		class: "d-image-viewer__preview-button",
		"aria-label": n.ariaLabel,
		importance: "clear",
		onClick: a.openModal
	}, {
		default: b(() => [p("img", {
			class: g(n.imageButtonClass),
			src: n.imageSrc,
			alt: n.imageAlt
		}, null, 10, C)]),
		_: 1
	}, 8, ["aria-label", "onClick"]), i.isOpen ? (_(), u(c, {
		key: 0,
		to: n.appendTo
	}, [p("div", h({
		"aria-hidden": i.isOpen ? "false" : "true",
		class: "d-modal",
		"data-qa": "dt-modal"
	}, e.modeAttrs, y(a.modalListeners, !0), {
		onMouseover: t[0] || (t[0] = (e) => i.showCloseButton = !0),
		onMouseleave: t[1] || (t[1] = (e) => i.showCloseButton = !1),
		onFocusin: t[2] || (t[2] = (e) => i.showCloseButton = !0),
		onFocusout: t[3] || (t[3] = (e) => i.showCloseButton = !1)
	}), [p("div", T, [p("img", {
		class: "d-image-viewer__full__image",
		src: n.imageSrc,
		alt: n.imageAlt
	}, null, 8, E)]), m(l, { name: "fade" }, {
		default: b(() => [i.showCloseButton ? (_(), u(o, {
			key: 0,
			ref: "closeImage",
			"data-qa": "dt-image-viewer-close-btn",
			class: "d-modal__close",
			circle: "",
			size: 400,
			importance: "clear",
			kind: "inverted",
			"aria-label": a.closeButtonTitle,
			title: a.closeButtonTitle,
			onClick: a.close
		}, {
			icon: b(() => [m(s, {
				class: "d-image-viewer__close-button",
				size: "400"
			})]),
			_: 1
		}, 8, [
			"aria-label",
			"title",
			"onClick"
		])) : (_(), u(x, {
			key: 1,
			onClose: a.close
		}, null, 8, ["onClose"]))]),
		_: 1
	})], 16, w)], 8, ["to"])) : d("", !0)]);
}
var O = /* @__PURE__ */ n(S, [["render", D]]);
//#endregion
export { O as default };

//# sourceMappingURL=image-viewer.js.map